const DEFAULT_JITSI_DOMAIN = "https://meet.jit.si";

function normalize(url: string): string {
  // Strip trailing slash
  return url.replace(/\/$/, "");
}

export function getJitsiDomain(): string {
  const fromEnv = import.meta.env.VITE_JITSI_DOMAIN;
  if (typeof fromEnv === "string" && fromEnv.trim()) {
    return normalize(fromEnv.trim());
  }
  return DEFAULT_JITSI_DOMAIN;
}

export function buildJitsiRoomUrl(roomName: string): string {
  const domain = getJitsiDomain();
  return `${domain}/${encodeURIComponent(roomName)}`;
}
